import { render, staticRenderFns } from "./HeroView.vue?vue&type=template&id=34628289&scoped=true"
import script from "./HeroView.vue?vue&type=script&lang=js"
export * from "./HeroView.vue?vue&type=script&lang=js"
import style0 from "./HeroView.vue?vue&type=style&index=0&id=34628289&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34628289",
  null
  
)

export default component.exports